import React, {Component} from "react";
import {InstitutionService} from "../../../../service/maintenance/institution/InstitutionService";
import {MAINTENANCE_INSTITUTIONS_ROUTE} from "../../../../utils/constants/RoutesConstants";
import Sign from "./SignView";
import {isValidData} from "../../../../utils/validator/Fields";
import {Growl} from "primereact/growl";

export default class SignContainer extends Component {
    constructor(props) {
        super(props);

        this.institutionService = new InstitutionService();

        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.pushDataSigns = this.pushDataSigns.bind(this);
        this.saveDialogSign = this.saveDialogSign.bind(this);

        this.state = {
            isLoading: false,
            returnPath: this.props.location.state.returnPath,
            institution: this.props.location.state.institution,
            contactList: this.props.location.state.contactList,
            signList: this.props.location.state.signList,
            actionScreen: this.props.location.state.actionScreen,
            idType: this.props.location.state.idType,
            signType: this.props.location.state.signType,
            dialogSign: {},
            errors: {},
            requiredFields: ['aPaterno', 'aMaterno', 'name', 'catSignType', 'catIdType',]
        }
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
            state: {
                returnPath: MAINTENANCE_INSTITUTIONS_ROUTE,
                activeIndex: 2,
                institution: this.state.institution,
                signList: this.state.signList,
                contactList: this.state.contactList,
                institutionId: this.state.institution.catInstitution.IdInstFinan,
            }
        });
    }

    saveDialogSign(event) {
        const {name, value} = event.target;
        let sign = this.state.dialogSign;
        sign[name] = value;
        this.setState({dialogSign: sign,})
    }

    pushDataSigns() {
        if (!isValidData(this.state.requiredFields, this.state.dialogSign)) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Debe llenar los campos requeridos correctamente'
            });
        } else {
            let newSign = {
                apellidoPaterno: this.state.dialogSign.aPaterno.trim(),
                apellidoMaterno: this.state.dialogSign.aMaterno.trim(),
                nombre: this.state.dialogSign.name.trim(),
                idTipoFirma: this.state.dialogSign.catSignType.IdTipoFirma,
                tipoFirma: this.state.dialogSign.catSignType.DescrTipoFirma,
                idIdentificacion: this.state.dialogSign.catIdType.IdIdentificacion,
                identificacion: this.state.dialogSign.catIdType.DescrIdentificacion,
                fechaVencimiento: this.state.dialogSign.fecVencimientoSign ?
                    this.state.dialogSign.fecVencimientoSign.getDate() + "-" +
                    (this.state.dialogSign.fecVencimientoSign.getMonth() + 1) + "-" +
                    this.state.dialogSign.fecVencimientoSign.getFullYear(): "",
            };

            let signListAux = this.state.signList;
            signListAux.push(newSign);
            this.setState({signList: signListAux});
            this.handleReturnButton();
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <Sign
                isLoading={this.state.isLoading}
                actionScreen={this.state.actionScreen}
                handleReturnButton={this.handleReturnButton}
                dialogSign={this.state.dialogSign}
                signType={this.state.signType}
                idType={this.state.idType}
                errors={this.state.errors}
                messagesGrowl={messagesGrowl}
                pushDataSigns={this.pushDataSigns}
                saveDialogSign={this.saveDialogSign}
            />)
    }
}